import { render, staticRenderFns } from "./nonthaburi.vue?vue&type=template&id=019af76f&scoped=true"
import script from "./nonthaburi.vue?vue&type=script&lang=js"
export * from "./nonthaburi.vue?vue&type=script&lang=js"
import style0 from "./nonthaburi.vue?vue&type=style&index=0&id=019af76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019af76f",
  null
  
)

export default component.exports